export default __webpack_public_path__ + "static/media/1447.66ffa055.png";